import MatchCard from './match_card';
import FantasyPlaceHolder from './fantasy_placeholder';
import Leaderboard from './leaderboard';
import TransactionHistory from './transaction_history';
import Loader from './loader';
export default {
  MatchCard,
  FantasyPlaceHolder,
  Leaderboard,
  TransactionHistory,
  Loader
};
